import { ChatPage } from "pages/Chat";

import Loader from "components/DesignSystem/Loader/loader";
import Documents from "components/documents/documents";
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useLocation,
  useParams,
  useRouteMatch,
} from "react-router-dom";
import { RestrictedRoute } from "RestrictedRoute";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { PageNotFound } from "components/design/PageNotFound";
import React, { Suspense, useEffect } from "react";
import { Ticket } from "components/Ticket/Tickets";
import { Tickets as CustomerTickets } from "components/Ticket/CustomerTicket/Tickets";
import { TodoList } from "pages/TodoList/TodoList";

const DocumentRoute = ({ appUrl }: { appUrl: string }) => {
  const history = useHistory();
  const { search } = useLocation();
  const { docId } = useParams<{ docId: string }>();

  const group = useCurrentGroupContext();
  const groupDocId = group.documents_group_id;

  useEffect(() => {
    history.replace(`${appUrl}/documents/${docId || groupDocId}${search}`);
  }, [appUrl, groupDocId, search, docId]);

  return <Documents appUrl={appUrl} />;
};

export const RoutesAccrossApps = () => {
  const { path } = useRouteMatch();
  const { isCustomer, isCpa } = useRoleBasedView();
  const group = useCurrentGroupContext();
  const unsortedFolderId = group.unsorted_folder_id;
  const { search } = useLocation();

  return (
    <Suspense fallback={<Loader />}>
      <Switch>
        <RestrictedRoute exact path={`${path}/chat/tickets`}>
          <Redirect to={`${path}/tickets`} />
        </RestrictedRoute>
        {isCustomer && (
          <RestrictedRoute exact path={`${path}/action-items`}>
            <Redirect to={`${path}/tickets`} />
          </RestrictedRoute>
        )}
        <RestrictedRoute
          path={`${path}/tickets`}
          render={() => {
            if (isCpa) {
              return <Ticket />;
            }

            return null;
          }}
        />
        <RestrictedRoute path={`${path}/tickets`}>
          <CustomerTickets />
        </RestrictedRoute>

        <RestrictedRoute exact path={`${path}/documents/unsorted`}>
          {!unsortedFolderId ? (
            <div className="t-w-full">
              <Loader />
            </div>
          ) : (
            <div>
              <Redirect to={`${path}/documents/${unsortedFolderId}${search}`} />
            </div>
          )}
        </RestrictedRoute>

        <RestrictedRoute path={`${path}/documents/:docId`}>
          <DocumentRoute appUrl={path} />
        </RestrictedRoute>

        <RestrictedRoute exact path={`${path}/documents`}>
          {!group.documents_group_id ? (
            <div className="t-w-full">
              <Loader />
            </div>
          ) : (
            <Redirect
              to={`${path}/documents/${group.documents_group_id}${search}`}
            />
          )}
        </RestrictedRoute>
        <RestrictedRoute exact path={`${path}/todolist`}>
          <TodoList />
        </RestrictedRoute>
        <RestrictedRoute path={`${path}/chat`} component={ChatPage} />
        <Route path="*" component={PageNotFound} />
      </Switch>
    </Suspense>
  );
};
